const getPackageVersion = () => process.env.VUE_APP_PACKAGE_VERSION

export default {
	namespaced: true,
	state: {
    // memu
    openMenu: false,
	},
  getters: {
		version: () => getPackageVersion() || '2.0.0',
		isMenuOpen: state => state.openMenu,
    menuItems: (state, getters, rootState, rootGetters) => {
      if(rootGetters['routing/routeName'] === 'home') return [];
      else return [
        {
          id: 'admin',
          name: 'ADMIN',
          visibility: 'admin',
          children: [
            {
              id: 'manage-users',
              name: 'Manage Users',
              link: '/admin/manage-users'
            },
            {
              id: 'customise',
              name: 'Customise',
              link: '/admin/customise'
            },
          ]
        },
      ]
    },
	},
	mutations: {
    OPEN_MENU(state, value) {
      state.openMenu = value
    },
	},
	actions: {
    updateCssSettings(context, areaColourScheme) {
      for (const colour in areaColourScheme) {
        // get current css var value
        const currentCssVar = getComputedStyle(document.body).getPropertyValue(`--${colour}`).trim();
        // skip out of iteration if
        // no global css var set or
        // values are the same already
        if (!currentCssVar || currentCssVar === areaColourScheme[colour]) continue
        // update css var
        const bodyStyles = document.body.style;
        bodyStyles.setProperty(`--${colour}`, areaColourScheme[colour])
      }
    },
	}
}
